"use client";

import { memo } from "react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

export interface FilterSelectProps {
	value: string;
	onValueChange: (val: string) => void;
	options: string[];
	placeholder: string;
	allLabel: string;
	icon?: React.ComponentType<{ className?: string }>;
}

export const FilterSelect = memo(function FilterSelect({
	value,
	onValueChange,
	options,
	placeholder,
	allLabel,
	icon: Icon,
}: FilterSelectProps) {
	if (options.length === 0) return null;
	return (
		<Select value={value} onValueChange={onValueChange}>
			<SelectTrigger
				className="w-28 h-9 bg-background text-xs"
				aria-label={placeholder}
			>
				{Icon && <Icon className="h-3.5 w-3.5 mr-1.5 shrink-0" />}
				<SelectValue placeholder={placeholder} />
			</SelectTrigger>
			<SelectContent className="w-full min-w-(--radix-select-trigger-width)">
				<SelectItem value="all">{allLabel}</SelectItem>
				{options.map((opt) => (
					<SelectItem key={opt} value={opt}>
						{opt}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
});

export type StockFilter = "in-stock" | "out-of-stock" | "all";

export interface StockFilterSelectProps {
	value: StockFilter;
	onChange: (val: StockFilter) => void;
}

export const StockFilterSelect = memo(function StockFilterSelect({
	value,
	onChange,
}: StockFilterSelectProps) {
	return (
		<Select value={value} onValueChange={(v) => onChange(v as StockFilter)}>
			<SelectTrigger className="w-32 h-9 text-xs" aria-label="Stock filter">
				<SelectValue />
			</SelectTrigger>
			<SelectContent className="w-full min-w-(--radix-select-trigger-width)">
				<SelectItem value="in-stock">In Stock</SelectItem>
				<SelectItem value="out-of-stock">Out of Stock</SelectItem>
				<SelectItem value="all">All Items</SelectItem>
			</SelectContent>
		</Select>
	);
});

export interface SortSelectProps {
	value: string;
	onValueChange: (val: string) => void;
	placeholder?: string;
}

export const SortSelect = memo(function SortSelect({
	value,
	onValueChange,
	placeholder = "Sort by",
}: SortSelectProps) {
	return (
		<Select value={value} onValueChange={onValueChange}>
			<SelectTrigger className="w-28 h-9 text-xs" aria-label="Sort meals">
				<SelectValue placeholder={placeholder} />
			</SelectTrigger>
			<SelectContent className="w-full min-w-(--radix-select-trigger-width)">
				<SelectItem value="best-selling">Featured</SelectItem>
				<SelectItem value="price-low">Price: Low</SelectItem>
				<SelectItem value="price-high">Price: High</SelectItem>
				<SelectItem value="name-asc">Name: A-Z</SelectItem>
				<SelectItem value="name-desc">Name: Z-A</SelectItem>
			</SelectContent>
		</Select>
	);
});
